/*
  SylverCar — chargement differe des diapositives de la galerie produit.

  Le probleme mesure

    La galerie est un carrousel Flickity en fondu : toutes les diapositives
    occupent la meme position dans la page. lazysizes, qui decide quoi charger
    d'apres la position a l'ecran, les considere donc toutes visibles et les
    telecharge toutes des le chargement.

    Releve sur « Coussin Dorsal Voiture » : neuf images pour 699 Ko, dont une
    seule est affichee. 596 Ko preleves pour des images que le visiteur ne
    verra que s'il fait defiler la galerie — environ trois secondes de bande
    passante en 4G lente, prises sur le chemin critique.

  Ce que fait ce fichier

    Liquid pose une classe neutre sur les diapositives au-dela de la premiere,
    que lazysizes ignore. Ce script leur rend leur classe le moment venu.

    Le parti pris est important : on ne SUPPRIME pas ces chargements, on les
    DECALE. Elles partent de toute facon peu apres le chargement de la page.
    Une galerie produit qui resterait blanche couterait des ventes, pas des
    points de score : le risque n'est pas symetrique, et le choix non plus.

    Trois declencheurs, au premier qui se presente :
      - le chargement de la page est termine (plus 250 ms de repit) ;
      - le visiteur touche la galerie ;
      - il change de variante, ce qui peut rendre active une diapositive
        jusque-la differee.
*/
(function () {
  'use strict';

  var MARQUE = 'sc-media-differee';
  var CLASSE_LAZY = 'lazyloadt4s';
  var fait = false;

  function promouvoir() {
    if (fait) return;
    fait = true;

    var differees = document.querySelectorAll('.' + MARQUE);
    if (!differees.length) return;

    var api = window.lazySizesT4;
    for (var i = 0; i < differees.length; i++) {
      var img = differees[i];
      img.classList.remove(MARQUE);
      img.classList.add(CLASSE_LAZY);
      // `unveil` demande le chargement immediat sans attendre le prochain
      // passage de l'observateur. Si l'API n'est pas la, la classe seule
      // suffit : lazysizes ramassera l'image a son prochain balayage.
      if (api && api.loader && typeof api.loader.unveil === 'function') {
        try { api.loader.unveil(img); } catch (e) {}
      }
    }
    if (api && api.loader && typeof api.loader.checkElems === 'function') {
      try { api.loader.checkElems(); } catch (e) {}
    }
  }

  function surInteraction(e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-t4s-gallery], .t4s-product__media-item, [data-product-single-media-group]')) {
      promouvoir();
    }
  }

  function demarrer() {
    if (!document.querySelector('.' + MARQUE)) return;

    // Un toucher sur la galerie, ou un changement de variante : on ne fait
    // pas attendre le visiteur.
    document.addEventListener('pointerdown', surInteraction, { passive: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"], [data-product-form]')) {
        promouvoir();
      }
    });

    // Filet garanti : de toute facon peu apres le chargement.
    if (document.readyState === 'complete') setTimeout(promouvoir, 250);
    else window.addEventListener('load', function () { setTimeout(promouvoir, 250); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
